import React, { useState } from 'react';
import { StarIcon, BadgeCheckIcon, PlusIcon } from 'lucide-react';
import { buildFeedReviews, FeedReview } from '../data/reviewFeed';
import { reviewSummary } from '../data/product';
const PAGE_SIZE = 6;
export function ReviewFeed() {
  const [items, setItems] = useState<FeedReview[]>(() => buildFeedReviews(0, PAGE_SIZE));
  const loadMore = () => {
    setItems(current => [...current, ...buildFeedReviews(current.length, PAGE_SIZE)]);
  };
  return <div className="mt-12 border-t border-white/10 pt-10" data-id="element-784" data-mp="2e4jjsgsj0nz0">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between" data-id="element-785" data-mp="2a6lttbqxlxuk">
        <h3 className="font-display text-3xl font-extrabold uppercase leading-none text-offwhite sm:text-4xl" data-id="element-786" data-mp="2554u3jk6ohfk">
          Verified reviews
        </h3>
        <p className="text-sm font-semibold uppercase tracking-wide text-steel-400" data-id="element-787" data-mp="tr14sqojjhgu">
          Showing {items.length} of {reviewSummary.reviewCount}
        </p>
      </div>

      <ul className="mt-6 grid gap-5 md:grid-cols-2 xl:grid-cols-3" data-id="element-788" data-mp="oqmwd7j125ia">
        {items.map(review => <li key={`${review.name}-${review.quote}`} className="flex" data-id="element-789" data-mp="364s7o3dcm8px">
            <article className="flex h-full w-full flex-col border border-white/12 bg-ink-950 p-5" data-id="element-790" data-mp="3a76roqsr7eis">
              <span className="flex items-center gap-1" aria-label="Rated 5 out of 5" data-id="element-791" data-mp="2w7xapowq4gdr">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-grit-500 text-grit-500" aria-hidden="true" data-id="element-792" data-mp="319mmx7von03f" />)}
              </span>
              <blockquote className="mt-3 text-[15px] leading-relaxed text-steel-200" data-id="element-793" data-mp="2r9vpoyfqm6zn">“{review.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-794" data-mp="2djiiwzel0ybw">
                <span aria-hidden="true" className="flex h-12 w-12 shrink-0 items-center justify-center font-display text-lg font-extrabold uppercase text-ink-950" style={{
              backgroundColor: review.tint
            }} data-id="element-795" data-mp="2iid9inisjr6k">
                  {review.monogram}
                </span>
                <span className="min-w-0" data-id="element-796" data-mp="1pgm0mra9wcvr">
                  <span className="flex items-center gap-1.5 font-display text-lg font-bold uppercase leading-none text-offwhite" data-id="element-797" data-mp="1knj3682dkjaa">
                    {review.name}
                    <BadgeCheckIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-798" data-mp="1fmdcefs9z63e" />
                  </span>
                  <span className="mt-1 block truncate text-[11px] font-semibold uppercase tracking-wide text-steel-500" data-id="element-799" data-mp="28d3m4qyj3gjk">
                    {review.trade}
                  </span>
                  <span className="mt-0.5 block text-[11px] font-bold uppercase tracking-wide text-grit-500" data-id="element-800" data-mp="23cg0kkt2jrwq">
                    {review.bought}
                  </span>
                </span>
              </div>
            </article>
          </li>)}
      </ul>

      <div className="mt-8 flex flex-col items-center gap-3" data-id="element-801" data-mp="n1lqiraof869">
        <button type="button" onClick={loadMore} className="flex w-full items-center justify-center gap-2 border-2 border-grit-500 px-6 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-grit-500 transition-[background-color,color,transform] duration-150 ease-grit hover:bg-grit-500 hover:text-ink-950 active:translate-y-[2px] sm:w-auto sm:text-2xl" data-id="element-802" data-mp="i0oaold52q7x">
          <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-803" data-mp="38e8t7c2l82ui" />
          See more reviews
        </button>
        <p className="text-[13px] text-steel-500" data-id="element-804" data-mp="3db8pwwdjrt8y">
          {reviewSummary.reviewCount} verified reviews · 4.9/5 average · new ones every day
        </p>
      </div>
    </div>;
}